import { Checkbox, type CheckboxProps } from "../core/Checkbox/Checkbox";
import { useFieldConnection, type ConnectedFieldProps } from "./useFieldConnection";

export interface CheckboxFieldProps
  extends Omit<CheckboxProps, "name">,
    ConnectedFieldProps {}

/**
 * Casilla conectada al formulario. Igual que `TextField`, pero sobre
 * `Checkbox` — que tiene su propio armado de label/error porque el label de
 * una casilla va a la derecha y admite enlaces dentro.
 */
export function CheckboxField({
  name,
  registerOptions,
  disabled,
  error,
  ...rest
}: CheckboxFieldProps) {
  const field = useFieldConnection(name, registerOptions);

  return (
    <Checkbox
      {...rest}
      disabled={disabled ?? field.disabled}
      error={error ?? field.error}
      {...field.registration}
    />
  );
}
